import React from 'react'
import { ColorType } from './Control'
import { LanguageContext } from '../contexts'
import classNames from 'classnames'
import { SpecialClassNames } from '../constants'

export interface ModalButton {
	color: ColorType
	text: string
	onClick: () => void
}

export interface CardModalProps extends ModalProps {
	title: string
	primaryButton?: ModalButton
	operationInProgress?: boolean
	footerNotification?: React.ReactElement
	className?: string
}

export function CardModal(props: CardModalProps) {
	const {localizedText} = React.useContext(LanguageContext)

	let primaryButton: React.ReactElement | null = null
	if (props.primaryButton) {
		const primaryButtonClass = classNames('button', props.primaryButton.color && `is-${props.primaryButton.color}`, { 'is-loading': props.operationInProgress })
		primaryButton = 
			<button className={primaryButtonClass} onClick={props.primaryButton.onClick} disabled={props.operationInProgress}>{props.primaryButton.text}</button>
	}

	const className = classNames('modal-card', SpecialClassNames.topZ, props.className)

	return (
		<div className='modal is-active'>
			<div className='modal-background' onClick={props.onCancel}></div>
			<div className={className} style={props.contentStyle}>

				<div className='modal-card-head'>
					<div className='modal-card-title'>{props.title}</div>
					<button className="delete" aria-label="close" onClick={props.onCancel}></button>
				</div>

				<div className='modal-card-body'>
					{props.children}
				</div>

				<div className='modal-card-foot'>
					{primaryButton}
					<button className='button' onClick={props.onCancel} disabled={props.operationInProgress}>{localizedText.Cancel}</button>
					{props.footerNotification}
				</div>
			</div>
		</div>
	)
}

export type ModalProps = React.PropsWithChildren<{
	onCancel?: () => void
	contentStyle?: React.CSSProperties
	className?: string
}>

export function Modal(props: ModalProps) {
	const className = classNames('modal-contents', SpecialClassNames.topZ, props.className)

	return (
		<div className='modal is-active'>
			<div className='modal-background' onClick={props.onCancel}></div>
			<div className={className} style={props.contentStyle}>
				{props.children}
			</div>
		</div>
	)
}